import { SxProps } from '@mui/material'

import variables from 'assets/styles/scss/shared/_variables.module.scss'

export const dialogStyles: SxProps = {
  width: '100%',
  textAlign: 'right',
}

export const formControl: any = {
  paddingBottom: '0.5 rem',
  width: 'fit-content',
}

export const switchElements: SxProps = {
  paddingBottom: '2.063rem',
}

export const textColor: SxProps = {
  color: variables.black,
}

export const formLabelParagraph: any = {
  margin: '0 0 0.625rem 0',
  ...textColor,
}

export const boxSize: SxProps = {
  display: 'flex',
  alignItems: 'center',
}

export const labelPadding = {
  paddingTop: '0.313rem',
}

export const alertBoxMargin: SxProps = {
  marginTop: '2.063rem',
}

export const fullWidth: SxProps = {
  width: '100%',
}
